import { createContext, useContext } from 'react';

import { AuthUser, type AuthUserType } from '@/common/types';

export const AuthContextInitialState = AuthUser.parse({});

export type AuthContextType = {
  authUser: AuthUserType;
  setAuthUser: (authUser: AuthUserType) => void;
};

export const AuthContext = createContext<AuthContextType>({
  authUser: AuthContextInitialState,
  setAuthUser: () => {},
});

export const useAuthContext = (): AuthContextType => useContext(AuthContext);
